import { parse } from "mathjs";

export const validateExpression = (expression) => {
    try {
        parse(expression);
        return true;
    }
    catch {
        return false;
    }
}
